import { Chip, Grid2 } from "@mui/material";

import { chartGranularityTypeList } from "api";
import { useFiltersContext } from "components/contexts";
import { useFormatMessage } from "lang";

export const ChartGranularityTypePicker = ({
  multiselect = false,
}: {
  multiselect?: boolean;
}) => {
  const formatMessage = useFormatMessage();
  const { chartGranularityType, setChartGranularityType } = useFiltersContext();

  return (
    <Grid2
      container
      spacing={1}
      sx={{
        justifyContent: "flex-start",
        flexWrap: "nowrap",
        overflowX: "auto",
        scrollbarGutter: "stable",
      }}
    >
      {chartGranularityTypeList.map((item) => {
        const isSelected = chartGranularityType.includes(item);

        const onClick = () => {
          if (!multiselect) setChartGranularityType([item]);
          else if (isSelected)
            setChartGranularityType(chartGranularityType.filter((i) => i !== item));
          else setChartGranularityType([...chartGranularityType, item]);
        };

        return (
          <Chip
            key={item}
            variant={isSelected ? "filled" : "outlined"}
            label={formatMessage(`chartGranularityType.${item}`)}
            onClick={onClick}
          />
        );
      })}
    </Grid2>
  );
};